import { apiClient } from '@/lib/api';
import type {
  AddTeamMemberInput,
  CreateTeamInput,
  TeamDetail,
  TeamListItem,
  TeamMemberData,
  UpdateTeamInput,
} from '../types/team';

const BASE = '/works-lite/teams';

export const teamsService = {
  listTeams(): Promise<TeamListItem[]> {
    return apiClient.get<TeamListItem[]>(BASE);
  },

  getTeam(id: number): Promise<TeamDetail> {
    return apiClient.get<TeamDetail>(`${BASE}/${id}`);
  },

  createTeam(data: CreateTeamInput): Promise<TeamDetail> {
    return apiClient.post<TeamDetail>(BASE, data);
  },

  updateTeam(id: number, data: UpdateTeamInput): Promise<TeamDetail> {
    return apiClient.patch<TeamDetail>(`${BASE}/${id}`, data);
  },

  deleteTeam(id: number): Promise<{ success: boolean }> {
    return apiClient.delete<{ success: boolean }>(`${BASE}/${id}`);
  },

  getTeamMembers(teamId: number): Promise<TeamMemberData[]> {
    return apiClient.get<TeamMemberData[]>(`${BASE}/${teamId}/members`);
  },

  addTeamMember(teamId: number, data: AddTeamMemberInput): Promise<TeamMemberData> {
    return apiClient.post<TeamMemberData>(`${BASE}/${teamId}/members`, data);
  },

  removeTeamMember(teamId: number, userId: number, newTeamLeadId?: number) {
    const qs = newTeamLeadId !== undefined ? `?newTeamLeadId=${newTeamLeadId}` : '';
    return apiClient.delete<{ success: boolean }>(`${BASE}/${teamId}/members/${userId}${qs}`);
  },
};
